import { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ContentPaper, ContentHeader } from './styled';
import { useAuthContext } from '../../contexts/AuthContext';
import GameHeader from './GameHeader';
import Preset from './Preset';
import Game from './Game';
import Result from './Result';
import Highscores from '../Highscores';
import ConfirmationDialog from '../Dialog/Confirmation';
import { replay } from '../../services/Student';
import { Alert, AlertTitle } from '@material-ui/lab';

const MainContainer = styled.div`
    /* display: flex;
    flex-direction: column; */
    height: 100%;
    box-sizing: border-box;
`;

export const BlockContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    /* height: calc(100% - 80px); */
    flex-wrap: wrap;
`;
export const Block = styled.div`
    margin-bottom: 16px;
    margin-left: 16px;
    box-sizing: border-box;

    &:first-child {
        margin-left: 0;
    }
`;
export const ImageBlock = styled(Block)`
    flex: 1;
    margin-bottom: 0;
    min-width: 200px;
`;

const StudentContent = ({ status, userToken, gameToken }) => {
    switch (status) {
        case 'init': {
            return <Preset />;
        }
        case 'sim':
        case 'highscores':
        case 'score': {
            // render game also when viewing highscores to keep component (state) in memory while
            // switching between game and highscores
            return (
                <>
                    <Game show={status === 'sim'} />
                    {status !== 'sim' && (
                        <ContentPaper>
                            <ContentHeader>Highscores</ContentHeader>
                            <Highscores gameToken={gameToken} />
                        </ContentPaper>
                    )}
                </>
            );
        }
        case 'ready':
            return <Result userToken={userToken} />;
        default:
            return <div>status {status} not supported</div>;
    }
};

const VIEW_GAME = 1;
const VIEW_HIGHSCORES = 2;

const Student = () => {
    const { t } = useTranslation();
    const { auth } = useAuthContext();
    const { game, gameStatus, replay: replaySetting } = auth;

    const [activeView, setActiveView] = useState(VIEW_GAME);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [replayError, setReplayError] = useState(false);

    if (!auth?.ready || !gameStatus?.status) {
        return <CircularProgress />;
    }

    const handleReplayClick = () => {
        setReplayError(false);
        setShowConfirmation(true);
    };

    const executeReplay = () => {
        replay(auth.token)
            .then(() => {
                window.location.reload();
                // setShowConfirmation(false);
            })
            .catch((err) => {
                setReplayError(
                    t('error.replayMessage', { error: err.message })
                );
            });
    };

    const contentView =
        activeView === VIEW_HIGHSCORES ? 'highscores' : gameStatus.status;

    const headerActions = [];

    if (
        (gameStatus.status !== 'init' && replaySetting === 2) ||
        ((gameStatus.status === 'ready' || gameStatus.status === 'score') &&
            replaySetting === 1)
    ) {
        headerActions.push({
            key: 'replay',
            label: t('buttons.replay'),
            onClick: handleReplayClick,
        });
    }
    let replayWarning = t('dialog.replayWarning', { returnObjects: true });
    if (Array.isArray(replayWarning)) {
        replayWarning = replayWarning.map((line, i) => <p key={i}>{line}</p>);
    }

    if (gameStatus.status !== 'score') {
        if (activeView !== VIEW_HIGHSCORES) {
            headerActions.push({
                key: 'highscores',
                label: t('buttons.highscores'),
                onClick: () => setActiveView(VIEW_HIGHSCORES),
            });
        }
        if (activeView !== VIEW_GAME) {
            headerActions.push({
                key: 'game',
                label: t('buttons.backToGame'),
                onClick: () => setActiveView(VIEW_GAME),
            });
        }
    }

    return (
        <MainContainer>
            <GameHeader
                title={game?.name}
                info={game?.info}
                actions={headerActions}
            />
            <StudentContent
                status={contentView}
                userToken={auth.token}
                gameToken={gameStatus.game}
            />
            <ConfirmationDialog
                open={showConfirmation}
                title="Waarschuwing"
                onCancel={() => {
                    setShowConfirmation(false);
                }}
                onAccept={executeReplay}
                closeOnly={Boolean(replayError)}
            >
                {replayError && (
                    <Alert severity="error">
                        <AlertTitle>{t('error.replayTitle')}</AlertTitle>
                        {replayError}
                    </Alert>
                )}
                {replayWarning}
            </ConfirmationDialog>
        </MainContainer>
    );
};
export default Student;
